// extracted by mini-css-extract-plugin
module.exports = {"item":"kH","dark":"kI","light":"kJ","toggle":"kK"};